import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import DDNJQuoteProposalInfoPageStore, {
  DDNJQuoteProposalInfoPageStoreContext,
  useDDNJQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/ddnj/pageStore';
import DDNJQuoteProposalInfoForm from 'components/quote/quote-proposal-info/DDNJ';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { isActionLoading, flowDelegate, canCompleteStep, onComplete, getInitialData } =
    useDDNJQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <DDNJQuoteProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const DDNJQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new DDNJQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <DDNJQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DDNJQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default DDNJQuoteProposalInfoPage;
